
import { defineComponent, ref } from 'vue'
import AgreementFormFieldNewMember from '@/components/agreements/form-fields/new-member.vue'
import { useAgreementModule } from '@/modules/agreements'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';

export default defineComponent({
    name: 'agreements-new-members',
    components: { AgreementFormFieldNewMember },
    props: {
        agreementId: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const { submitForm, createOnSuccess } = useFormModule()
        const { addMemberToAgreement, getAgreementAvailableMembers, getAgreementMembers } = useAgreementModule()

        const form = ref<QForm>()
        const newMemberModel = ref('')

        const sendRequest = async () => addMemberToAgreement(props.agreementId, newMemberModel.value)

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Member added to agreement')
        ).then(() => {
            getAgreementAvailableMembers(props.agreementId)
            getAgreementMembers((props.agreementId))
            newMemberModel.value = ''
        })

        return {
            newMemberModel,
            onSubmit,
            form
        }
    }
})
